exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".wKSnce4S-_bYKdzAtbryo{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.wKSnce4S-_bYKdzAtbryo,.BVm5dNjVgXFFtbVIZ3TjC{color:var(--neutralPrimary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.BVm5dNjVgXFFtbVIZ3TjC{font-size:12px;font-weight:400;display:block}", ""]);
// Exports
exports.locals = {
	"detail": "wKSnce4S-_bYKdzAtbryo",
	"detailText": "BVm5dNjVgXFFtbVIZ3TjC"
};